export default __webpack_public_path__ + "static/media/restaurant-1-rMAX.99e5b76f.jpg";